module.exports = __webpack_public_path__ + "img/havefun_title_sc.a39e5acd.jpg";